import { useEffect, useState } from "react";
import { addDays } from "date-fns";

import {
  getEndOfDayTimestamp,
  getLocalDateString,
  getStartOfDayTimestamp,
} from "../../utils";
import { fetchEventStats } from "../../services/events";
import classes from "./Utilization.module.css";
import Input from "../../components/Inputs/Input";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import DashboardCard from "./DashboardCard";
import InputLabel from "../../components/Inputs/InputLabel";

const Utilization = () => {
  const [startDate, setStartDate] = useState(
    getStartOfDayTimestamp(
      getLocalDateString(addDays(new Date(), -6).getTime())
    )
  );
  const [endDate, setEndDate] = useState(
    getEndOfDayTimestamp(getLocalDateString(Date.now()))
  );
  const [eventStates, setEventStates] = useState({
    eventCount: 0,
    registered: 0,
    checkedIn: 0,
    medicationsAdministered: [],
  });
  const utilization =
    eventStates.registered !== 0
      ? (eventStates.checkedIn / eventStates.registered) * 100
      : 0;

  const fetchEventsStats = async () => {
    try {
      const { status, data } = await fetchEventStats(startDate, endDate);
      if (status && data) {
        setEventStates(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchEventsStats();
  }, []);

  const utilizationCardData = [
    {
      name: "Total Events",
      value: eventStates.eventCount,
      color: "#e4f5f9",
    },
    {
      name: "Total Registered",
      value: eventStates.registered,
      color: "#F4F6FA",
    },
    {
      name: "Total Check-ins",
      value: eventStates.checkedIn,
      color: "#EAECFC",
    },
    {
      name: "Utilization",
      value: utilization.toFixed(1) + "%",
      color: "#cfe5d1",
    },
  ];

  return (
    <div className={classes.main}>
      <div className={classes.filters}>
        <div>
          <Input
            type='date'
            name='Start Date'
            className={classes.filterDates}
            value={getLocalDateString(startDate)}
            onChange={(e) => {
              const startDate = getStartOfDayTimestamp(e.target.value);
              setStartDate(startDate);
              if (startDate > endDate)
                setEndDate(getEndOfDayTimestamp(e.target.value));
            }}
          />
          <Input
            type='date'
            name='End Date'
            className={classes.filterDates}
            value={getLocalDateString(endDate)}
            onChange={(e) => setEndDate(getEndOfDayTimestamp(e.target.value))}
            min={getLocalDateString(startDate)}
          />
        </div>
        <PrimaryButton
          name='Filter'
          onClick={fetchEventsStats}
          className={classes.filterBtn}
        />
      </div>
      <div className={classes.content}>
        {utilizationCardData.map((card, idx) => (
          <DashboardCard {...card} key={idx} className={classes.card} />
        ))}
      </div>
      <div className={classes.vaccines}>
        <InputLabel label='Medications Administered:' />
        <div className={classes.medicationCard}>
          {eventStates.medicationsAdministered
            .sort((a: any, b: any) => b?.count - a?.count)
            .map((medication: any, idx) => (
              <div className={classes.medications} key={idx}>
                <div className={classes.medicationName}>{medication?.name}</div>
                <div className={classes.medicationCount}>
                  {medication?.count}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Utilization;
